

export default {
    name: 'DisableNotifications',
    data () {
        return {
            disableForm: new this.$vForm({
                disabled: []
            }),
            notificationsForm: new this.$vForm(),
            notifications: [],
            disabled: [],
            loading: {},
            isLoadingNotifications: true
        }
    },
    mounted () {
        this.notificationsForm.get('/v1/notifiable-tunable-notifications')
            .then((res) => {
                const { notifications, disabled } = res.data
                this.notifications = notifications
                this.disabled = [...disabled]
                this.disableForm.disabled = [...disabled]
                this.isLoadingNotifications = false
            })
    },
    methods: {
        groupBy (xs, key) {
            return xs.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x)

                return rv
            }, {})
        },
        toggleLoadingState (notifiableId) {
            if (this.loading[notifiableId]) {
                return
            }
            this.$set(this.loading, notifiableId, true)
            this.updateNotificationsToggle(notifiableId)
            this.send(notifiableId)
        },
        updateNotificationsToggle (notifiableId) {
            if (this.disableForm.disabled.includes(notifiableId)) {
                this.disableForm.disabled = this.disableForm.disabled.filter(d => d !== notifiableId)
            } else {
                this.disableForm.disabled.push(notifiableId)
            }
        },
        send (notifiableId) {
            this.disableForm.post('/v1/notifiable-tunable-notifications')
                .then(async (res) => {
                    this.disabled = [...res.data]
                    this.disableForm.disabled = [...res.data]
                    this.$set(this.loading, notifiableId, false)
                })
                .catch((err) => {
                    this.$toast.error('حدث خطأ ما')
                    this.updateNotificationsToggle(notifiableId)
                    this.$set(this.loading, notifiableId, false)
                    throw err
                })
        },
        getIcon (channel) {
            const icons = {
                database: 'web',
                sms: 'sms-01',
                mail: 'email'
            }
            return icons[channel] || 'web'
        }
    }
}
